/** Public marketing paths from `website/website.routes.ts`. */
export const QUICK_TOUR_MARKETING_PATHS: readonly string[] = [
    '/home',
    '/about',
    '/agents',
    '/contact',
    '/faq',
    '/privacy',
    '/terms',
    '/thanks',
];

/**
 * Routes where the org-admin Quick Tour must not auto-start.
 * Standalone viewers use `layout: 'empty'` (no sidebar); starting the tour would navigate away.
 */
export function isQuickTourAutoStartBlockedRoute(path: string): boolean {
    if (
        path.includes('sign') ||
        path.includes('otp') ||
        path.includes('password')
    ) {
        return true;
    }

    if (QUICK_TOUR_MARKETING_PATHS.some((p) => path === p || path.startsWith(`${p}/`))) {
        return true;
    }

    if (
        path.includes('/dashboards/view/') ||
        path.includes('/report/') ||
        path.includes('report-new') ||
        path.includes('/form/') ||
        path.includes('add-tracker')
    ) {
        return true;
    }

    return false;
}
